export default {
      id: "logo_publicis-usage",
      viewBox: "0 0 232 226",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#logo_publicis",
      toString: function () {
        return this.url;
      }
    }